import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth.js";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        layout: "AuthLayout",
        public: true
      },
      component: () => import("@/views/Auth/LoginView.vue"),
    },
    {
      path: "/forgotpassword",
      name: "forgot-password",
      meta: {
        layout: "AuthLayout",
        public: true
      },
      component: () => import("@/views/Auth/ForgotPassword.vue"),
    },

    // {
    //   path: "/reset-password",
    //   name: "reset-password",
    //   meta: {
    //     public: true,
    //   },
    //   component: () => import("@/views/auth/ResetPassword.vue"),

    //   props: (route) => ({
    //     token: route.query.token,
    //     email: route.query.email,
    //     public: true
    //   }),
    // },

    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        layout: "AuthLayout",
        public: true,
      },
      component: () => import("@/views/auth/ResetPassword.vue"),
      props: (route) => ({
        token: route.query.token,
        email: route.query.email,
      }),
    },

    //rutas nuevas
    //profile
    {
      path: "/profile",
      name: "profile",
      meta: {
        layout: "MainLayout",
        requiresAuth: true,
        title: "Mi perfil",
      },
      component: () => import("@/views/User/ProfileView.vue"),
    },
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/views/Dashboard/IndexDashboard.vue"),
      meta: {
        iconClass: "fa fa-dashboard",
        menuName: "Dashboard",
        showSidebar: true,
        permission: "dashboard",
        layout: "MainLayout",
        requiresAuth: true,
        title: "Dashboard",
      },
    },
    {
      path: "/minsalud",
      name: "minsalud",
      component: () => import("@/views/Minsalud/MinsaludDashboard.vue"),
      meta: {
        iconClass: "fa-solid fa-heart-pulse",
        menuName: "Minsalud",
        showSidebar: true,
        permission: "dashboard",
        layout: "MainLayout",
        requiresAuth: true,
        title: "Minsalud - Interoperabilidad de la Historia Clínica Electrónica (IHCE)",
      },
    },
    {
      path: "/tablero/sala",
      name: "tablero.sala",
      component: () => import("@/views/Tablero/Sala/MainViewTableroSala.vue"),
      meta: {
        iconClass: "fa-solid fa-tv",
        menuName: "Tablero",
        showSidebar: true,
        permission: "tablero.sala",
        layout: "TableroLayout",
        requiresAuth: true,
        title: "Tablero sala",
      },
    },
    {
      path: "/historiaclinica/condsaludantecedentemedico/:token",
      name: "historiaclinica.condsaludantecedentemedico",
      component: () =>
        import(
          "@/views/HistoriaClinica/CondSaludAntecedenteMed/CondSaludAntecedenteMed.vue"
        ),
      meta: {
        showSidebar: false,
        title: "Condicines de salud y antecedentes médicos",
        mainView: "consultaexterna",
        reload: false,
        layout: "FormAntecedenteMedicoLayout",
        public: true
      },
    },

    {
      path: "/tablero/salaespera",
      name: "tablero.salaespera",
      component: () => import("@/views/Tablero/SalaEspera/MainViewTableroSalaEspera.vue"),
      meta: {
        iconClass: "fa-solid fa-tv",
        menuName: "Tablero",
        showSidebar: true,
        permission: "tablero.salaespera",
        layout: "TableroLayout",
        requiresAuth: true,
        title: "Tablero sala",
      },
    },
    // //paciente
    {
      path: "/paciente",
      name: "paciente",
      component: () => import("@/views/Pacientes/IndexPacientes.vue"),
      meta: {
        iconClass: "fa-solid fa-user",
        menuName: "Paciente",
        showSidebar: true,
        title: "Paciente",
        layout: "MainLayout",
        permission: "paciente",
        requiresAuth: true,
      },
      children: [
        {
          path: "nuevo",
          name: "paciente.nuevo",
          component: () =>
            import("@/views/Pacientes/pages/FormularioPaciente.vue"),
          meta: {
            menuName: "Nuevo Paciente",
            showSidebar: false,
            title: "Nuevo paciente",
            mainView: "paciente",
            reload: true,
            permission: "paciente.create",
          },
        },
        {
          path: "view/id/:id",
          name: "paciente.view",
          meta: { menuName: "Nuevo Paciente", showSidebar: false },
          component: () =>
            import("@/views/Pacientes/pages/Paciente/IndexPaciente.vue"),
          props: true,
          meta: {
            mainView: "paciente",
            showSidebar: false,
            permission: "paciente",
            layout: "MainLayout",
            reload: false,
          },
          children: [
            {
              path: "cirugia",
              name: "paciente.view.cirugia",
              props: true,
              component: () =>
                import("@/views/Pacientes/pages/Cirugia/IndexCirugia.vue"),
              meta: {
                title: "Agendamiento cirugía",
                showSidebar: false,
                mainView: "paciente.view",
              },
              children: [
                {
                  path: ":eventoid",
                  name: "paciente.view.cirugia.edit",
                  props: true,
                  component: () =>
                    import("@/views/Pacientes/pages/Cirugia/IndexCirugia.vue"),
                },
              ],
            },
            {
              path: "edit",
              name: "paciente.edit",
              props: true,
              component: () =>
                import("@/views/Pacientes/pages/FormularioPaciente.vue"),
            },
            {
              path: "consulta",
              name: "paciente.view.consulta",
              props: true,
              component: () =>
                import("@/views/Pacientes/pages/Consulta/IndexConsulta.vue"),
              meta: {
                title: "Agendamiento consulta externa",
                showSidebar: false,
                mainView: "paciente.view",
                permission: "paciente",
              },
              children: [
                {
                  path: ":eventoid",
                  name: "paciente.view.consulta.edit",
                  props: true,
                  component: () =>
                    import(
                      "@/views/Pacientes/pages/Consulta/IndexConsulta.vue"
                    ),
                  meta: {
                    title: "Editar consulta externa",
                    showSidebar: false,
                    mainView: "paciente.view",
                  },
                },
              ],
            },
            {
              path: "consulta/:eventoid/cancelar",
              name: "paciente.view.consulta.cancelar",
              props: true,
              component: () =>
                import("@/views/Pacientes/pages/Consulta/CancelarConsulta.vue"),
            },
          ],
        },
      ],
    },
    // Tercero
    {
      path: "/tercero",
      name: "tercero",
      component: () => import("@/views/Tercero/MainViewTercero.vue"),
      meta: {
        iconClass: "fa-solid fa-users",
        menuName: "Tercero",
        showSidebar: true,
        title: "Tercero",
        layout: "MainLayout",
        permission: "tercero",
        requiresAuth: true,
      },
      children: [
        {
          path: "nuevo",
          name: "tercero.create",
          component: () => import("@/views/Tercero/pages/FormTercero.vue"),
          meta: {
            showSidebar: false,
            title: "Crear tercero",
            mainView: "tercero",
            reload: true,
            permission: "tercero.create",
          },
        },
        {
          path: "view/id/:id",
          name: "tercero.view",
          component: () => import("@/views/Tercero/pages/FormTercero.vue"),
          props: true,
          meta: {
            showSidebar: false,
            title: "Tercero",
            mainView: "tercero",
            reload: true,
            permission: "tercero",
          },
        },
      ],
    },
    // consulta externa
    {
      path: "/consultaexterna",
      name: "consultaexterna",
      component: () => import("@/views/ConsultaExterna/Index.vue"),
      meta: {
        iconClass: "fa-solid fa-file-medical",
        menuName: "Consulta Externa",
        title: "Consulta externa",
        showSidebar: true,
        permission: "consultaexterna",
        layout: "MainLayout",
      },
      children: [
        {
          path: ":id",
          name: "consultaexterna.show",
          component: () => import("@/views/ConsultaExterna/pages/Show.vue"),
          props: true,
          meta: {
            showSidebar: false,
            title: "Consulta externa",
          },
          children: [
            {
              path: "historiaclinica/aperturahistoria",
              name: "consultaexterna.historiaclinica.apertura",
              props: true,
              component: () =>
                import("@/views/HistoriaClinica/Apertura/IndexAperturaHc.vue"),
              meta: {
                showSidebar: false,
                title: "Apertura historia clínica",
                mainView: "consultaexterna",
                reload: false,
              },
            },
            {
              path: "historiaclinica/consentimientoinformado",
              name: "consultaexterna.historiaclinica.consentimientoinformado",
              component: () =>
                import(
                  "@/views/HistoriaClinica/ConsentimientoInformado/Index.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Consentimiento informado",
                mainView: "consultaexterna",
                reload: false,
              },
            },
            {
              path: "historiaclinica/examenparaclinico",
              name: "consultaexterna.historiaclinica.examenparaclinico",
              props: true,
              component: () =>
                import(
                  "@/views//HistoriaClinica/ExamenesParaclinicos/ExamenParaclinicoMainView.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Exámenes paraclínicos",
                mainView: "consultaexterna",
                reload: false,
              },
            },
            {
              path: "historiaclinica/examenparaclinico/nuevo",
              name: "consultaexterna.historiaclinica.examenparaclinico.nuevo",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/ExamenesParaclinicos/FormExamenParaclinico.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Registro exámen paraclínico",
                mainView: "consultaexterna.historiaclinica.examenparaclinico",
                reload: false,
              },
            },
            {
              path: "historiaclinica/examenparaclinico/view/id/:examenId",
              name: "consultaexterna.historiaclinica.examenparaclinico.view",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/ExamenesParaclinicos/FormExamenParaclinico.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Exámen paraclínico",
                mainView: "consultaexterna.historiaclinica.examenparaclinico",
                reload: false,
              },
            },
            {
              path: "historiaclinica/examenparaclinico/edit/id/:examenId",
              name: "consultaexterna.historiaclinica.examenparaclinico.edit",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/ExamenesParaclinicos/FormExamenParaclinico.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Editar exámen paraclínico",
                mainView: "consultaexterna.historiaclinica.examenparaclinico",
                reload: false,
              },
            },
            {
              path: "historiaclinica/valoracion",
              name: "consultaexterna.historiaclinica.valoracion",
              props: true,
              component: () =>
                import(
                  "../views/HistoriaClinica/Valoracion/IndexValoracion.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Valoración consulta externa",
                mainView: "consultaexterna",
                reload: false,
              },
            },

            {
              path: "historiaclinica/documentos",
              name: "consultaexterna.historiaclinica.documentos",
              component: () =>
                import(
                  "@/views/HistoriaClinica/Documentos/IndexDocumentos.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Documentos historia",
                mainView: "consultaexterna",
                reload: false,
              },
            },
          ],
        },
      ],
    },

    // cirugia
    {
      path: "/cirugia",
      name: "cirugia",
      component: () => import("@/views/Cirugia/Index.vue"),
      meta: {
        iconClass: "fa-solid fa-syringe",
        menuName: "Cirugia",
        showSidebar: true,
        title: "Cirugía",
        layout: "MainLayout",
        permission: "cirugia",
      },
      children: [
        {
          path: ":eventoid/hojagastos/canastainsumo",
          name: "hojagastos.cirugia.canastainsumo",
          props: true,
          component: () =>
            import("../views/HojaGastos/CanastaInsumo/MainViewCanastaInsumo.vue"),
          meta: {
            showSidebar: false,
            reload: false,
            layout: "MainLayout",
            permission: "hojagastos.cirugia.canastainsumo",
            title: "Canasta insumos cirugía",
            mainView: "cirugia",
          },
        },
        {
          path: ":eventoid/hojagastos/checkhoja",
          name: "hojagastos.cirugia.checkhoja",
          props: true,
          component: () =>
            import("../views/HojaGastos/CheckInsumo/MainViewCheckInsumo.vue"),
          meta: {
            showSidebar: false,
            reload: false,
            layout: "MainLayout",
            permission: "hojagastos.cirugia",
            title: "Insumos hoja de gastos cirugía",
            mainView: "cirugia",
          },
        },
        {
          path: ":id",
          name: "cirugia.show",
          component: () => import("../views/Cirugia/pages/Show.vue"),
          props: true,
          meta: {
            showSidebar: false,
          },
          children: [
            {
              path: "historiaclinica/formatoshistoria",
              name: "cirugia.historiaclinica.formatoshistoria",
              component: () =>
                import("@/views/HistoriaClinica/FormatoHc/IndexFormatoHc.vue"),
              props: true,
              meta: {
                title: "Formatos historia clínica",
                permission: "hc.formatoshistoria",
                showSidebar: false,
                mainView: "cirugia",
                reload: false,
              },
            },
            {
              path: "historiaclinica/aperturahistoria",
              name: "cirugia.historiaclinica.apertura",
              title: "Apertura de historia clínica",
              props: true,
              component: () =>
                import("@/views/HistoriaClinica/Apertura/IndexAperturaHc.vue"),
              meta: {
                showSidebar: false,
                mainView: "cirugia",
              },
            },
            {
              path: "historiaclinica/descripcionquirurgica",
              name: "cirugia.historiaclinica.descripcionquirurgica",
              title: "Descripción quirúrgica",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/DescripcionQuirurgica/DescQuirurgicaMainView.vue"
                ),
              meta: {
                layout: "MainLayout",
                showSidebar: false,
                title: "Descripción quirúrgica",
                permission: "hc.descripcionquirurgica",
                mainView: "cirugia",
              },
            },
            {
              path: "historiaclinica/recordanestesia",
              name: "cirugia.historiaclinica.recordanestesia",
              title: "record anestesia",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/RecordAnestesia/RecordAnestesia.vue"
                ),
              meta: {
                layout: "MainLayout",
                showSidebar: false,
                title: "Record anestesia",
                permission: "hc.descripcionquirurgica",
                mainView: "cirugia",
              },
            },
            {
              path: "historiaclinica/descripcionquirurgica/edit/id/:descrQuirId",
              name: "cirugia.historiaclinica.descripcionquirurgica.edit",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/DescripcionQuirurgica/DescQuirurgicaMainView.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Editar descripción quirúrgica",
                mainView: "cirugia",
                reload: false,
              },
            },
            {
              path: "historiaclinica/consentimientoinformado",
              name: "cirugia.historiaclinica.consentimientoinformado",
              props: true,
              component: () =>
                import(
                  "@/views/HistoriaClinica/ConsentimientoInformado/Index.vue"
                ),
              meta: {
                showSidebar: false,
                mainView: "cirugia",
                reload: false,
                title: "Consentimiento informado",
              },
            },
            {
              path: "historiaclinica/valoracionanestesica",
              name: "historiaclinica.valoracionanestesica",
              component: () =>
                import(
                  "@/views/HistoriaClinica/ValoracionAnestesicaQuirurgica/IndexValoracionAnestesica.vue"
                ),
              meta: {
                showSidebar: false,
                title: "Valoración anestésica quirúrgica",
                permission: "hc.valoracionanestesicaquirurgica",
                mainView: "cirugia",
                reload: true,
              },
              props: true,
            },
          ],
        },
      ],
    },
    //recuperacion
    {
      path: "/recuperacion",
      name: "recuperacion",
      component: () => import("@/views/Recuperacion/Index.vue"),
      meta: {
        iconClass: "fa-solid fa-file-waveform",
        menuName: "Recuperacion",
        showSidebar: true,
        title: "Recuperación",
        permission: "recuperacion",
        layout: "MainLayout",
      },
      children: [
        {
          path: ":eventoid/hojagastos/checkhoja",
          name: "hojagastos.recuperacion.checkhoja",
          props: true,
          component: () =>
            import("../views/HojaGastos/CheckInsumo/MainViewCheckInsumo.vue"),
          meta: {
            showSidebar: false,
            reload: false,
            layout: "MainLayout",
            permission: "hojagastos.recuperacion",
            title: "Insumos hoja de gastos recuperacion",
            mainView: "recuperacion",
          },
        },
        {
          path: ":id",
          name: "recuperacion.show",
          component: () => import("@/views/Recuperacion/pages/Show.vue"),
          props: true,
          meta: {
            showSidebar: false,
          },
          children: [
            {
              path: "historiaclinica/formatoshistoria",
              name: "recuperacion.historiaclinica.formatoshistoria",
              component: () =>
                import("@/views/HistoriaClinica/FormatoHc/IndexFormatoHc.vue"),
              props: true,
              meta: {
                title: "Formatos historia clínica",
                permission: "hc.formatoshistoria",
                showSidebar: false,
                mainView: "recuperacion",
                reload: false,
              },
            },
          ],
        },
      ],
    },

    // hospitalizacion
    {
      path: "/hospitalizacion",
      name: "hospitalizacion",
      component: () => import("@/views/Hospitalizacion/Index.vue"),
      meta: {
        iconClass: "fa-solid fa-hospital",
        menuName: "Hospitalización",
        showSidebar: true,
        title: "Hospitalización",
        layout: "MainLayout",
        permission: "hospitalizacion",
      },
      children: [
        {
          path: ":eventoid/hojagastos/checkhoja",
          name: "hojagastos.hospitalizacion.checkhoja",
          props: true,
          component: () =>
            import("../views/HojaGastos/CheckInsumo/MainViewCheckInsumo.vue"),
          meta: {
            showSidebar: false,
            reload: false,
            layout: "MainLayout",
            permission: "hojagastos.hospitalizacion",
            title: "Insumos hoja de gastos hospitalización",
            mainView: "hospitalizacion",
          },
        },
        {
          path: ":id",
          name: "hospitalizacion.show",
          component: () => import("@/views/Hospitalizacion/pages/Show.vue"),
          props: true,
          meta: {
            showSidebar: false,
          },
          children: [
            {
              path: "historiaclinica/formatoshistoria",
              name: "hospitalizacion.historiaclinica.formatoshistoria",
              component: () =>
                import("@/views/HistoriaClinica/FormatoHc/IndexFormatoHc.vue"),
              props: true,
              meta: {
                title: "Formatos historia clínica",
                permission: "hc.formatoshistoria",
                showSidebar: false,
                mainView: "hospitalizacion",
                reload: false,
              },
            },
          ],
        },
        {
          path: "new",
          name: "hospitalizacion.create",
          component: () =>
            import("@/views/Hospitalizacion/pages/FormHospitalizacion.vue"),
          meta: {
            showSidebar: false,
            title: "Nueva hospitalización",
            mainView: "hospitalizacion",
            permission: "hospitalizacion.create",
            reload: true,
          },
        },
      ],
    },
    // programacion
    {
      path: "/programacion",
      name: "programacion",
      component: () => import("@/views/Programacion/IndexProgramacion.vue"),
      meta: {
        iconClass: "fa-solid fa-calendar-days",
        menuName: "Programación",
        showSidebar: true,
        title: "Programación",
        layout: "MainLayout",
        permission: "programacion",
      },
      children: [
        {
          path: "cirugia",
          name: "programacion.cirugia",
          component: () =>
            import("@/views/Programacion/cirugia/ProgCirugiaMainView.vue"),
          meta: {
            showSidebar: false,
            title: "Programación",
            layout: "MainLayout",
            permission: "programacion",
          },
        },
        {
          path: "consultaexterna",
          name: "programacion.consultaexterna",
          component: () =>
            import(
              "@/views/Programacion/consultaexterna/ProgConsultaMainView.vue"
            ),
          meta: {
            showSidebar: false,
            title: "Programación",
            layout: "MainLayout",
            permission: "programacion",
          },
        },
      ],
    },
    // hoja de gasto

    {
      path: "/hojagastos/cirugia/:id",
      name: "hojagastos.cirugia",
      component: () =>
        import("../views/HojaGastos/Cirugia/IndexHojaCirugia.vue"),
      meta: {
        showSidebar: false,
        layout: "HojaGastoLayout",
        permission: "hojagastos.cirugia",
      },
    },

    // {
    //   path: "/hojagastos/cirugia/checkhoja/:eventoid",
    //   name: "hojagastos.cirugia.checkhoja",
    //   props: true,
    //   component: () =>
    //     import("../views/HojaGastos/CheckInsumo/MainViewCheckInsumo.vue"),
    //   meta: {
    //     showSidebar: false,
    //     reload: false,
    //     layout: "MainLayout",
    //     permission: "hojagastos.cirugia",
    //     title: "Insumos hoja de gastos cirugía",
    //     mainView: "cirugia",
    //   },
    // },
    {
      path: "/hojagastos/recuperacion/:id",
      name: "hojagastos.recuperacion",
      component: () =>
        import("../views/HojaGastos/Recuperacion/IndexHojaRecuperacion.vue"),
      meta: {
        showSidebar: false,
        layout: "HojaGastoLayout",
        permission: "hojagastos.recuperacion",
      },
    },
    {
      path: "/hojagastos/hospitalizacion/:id",
      name: "hojagastos.hospitalizacion",
      component: () =>
        import(
          "../views/HojaGastos/Hospitalizacion/IndexHojaHospitalizacion.vue"
        ),
      meta: {
        showSidebar: false,
        layout: "HojaGastoLayout",
        permission: "hojagastos.hospitalizacion",
      },
    },
    // facturacion
    {
      path: "/facturacion",
      name: "facturacion",
      component: () => import("@/views/facturacion/FacturacionMainView.vue"),
      meta: {
        iconClass: "fa-solid fa-file-invoice-dollar",
        menuName: "Facturación",
        permission: "facturacion",
        showSidebar: true,
        layout: "MainLayout",
        title: "Facturación",
      },
      children: [
        {
          path: "consulta/:consultaId",
          name: "facturacion.consulta.new",
          props: true,
          meta: {
            showSidebar: false,
            title: "Facturar consulta",
            mainView: "facturacion",
          },
          component: () =>
            import("../views/facturacion/pages/consulta/facturaConsulta.vue"),
        },
        {
          path: "cirugia/:cirugiaId",
          name: "facturacion.cirugia.new",
          props: true,
          meta: {
            showSidebar: false,
            title: "Facturar cirugía",
            mainView: "facturacion",
          },
          component: () =>
            import("../views/facturacion/pages/cirugia/facturaCirugia.vue"),
        },
        {
          path: "hospitalizacion/:hospitalizacionId",
          name: "facturacion.hospitalizacion.new",
          props: true,
          meta: {
            showSidebar: false,
            title: "Facturar hospitalización",
            permission: "facturacion",
            mainView: "facturacion",
          },
          component: () =>
            import(
              "../views/facturacion/pages/hospitalizacion/facturaHospitalizacion.vue"
            ),
        },
      ],
    },
    // paramentrizacion
    {
      path: "/parametrizacion",
      name: "parametrizacion",
      component: () =>
        import("@/views/Parametrizacion/IndexParametrizacion.vue"),
      meta: {
        iconClass: "fa-solid fa-gear",
        menuName: "Parametrización",
        showSidebar: true,
        layout: "MainLayout",
        title: "Parametrización",
        permission: "parametrizacion",
      },
    },
    {
      path: "/parametrizacion/impuestos/impuesto",
      name: "parametrizacion.impuestos.impuesto",
      component: () =>
        import(
          "@/views/Parametrizacion/Impuestos/Impuesto/ImpuestoMainView.vue"
        ),
      meta: {
        permission: "parametrizacion.impuestos.impuesto",
        showSidebar: false,
        title: "Impuestos",
        layout: "MainLayout",
        mainView: "parametrizacion",
      },
    },
    {
      path: "/parametrizacion/impuestos/retencion",
      name: "parametrizacion.impuestos.retencion",
      component: () =>
        import(
          "@/views/Parametrizacion/Impuestos/Retencion/RetencionMainView.vue"
        ),
      meta: {
        permission: "parametrizacion.impuestos.retencion",
        showSidebar: false,
        title: "Retenciones",
        layout: "MainLayout",
        mainView: "parametrizacion",
      },
    },
    {
      path: "/parametrizacion/rolepermission",
      name: "parametrizacion.rolepermission",
      component: () =>
        import(
          "@/views/Parametrizacion/RolePermission/RolePermissionMainView.vue"
        ),
      meta: {
        permission: "parametrizacion.rolepermission",
        menuName: "Parametrización",
        showSidebar: false,
        title: "Administración de roles y permisos",
        layout: "MainLayout",
        mainView: "parametrizacion",
      },
    },

    {
      path: "/parametrizacion/usuario",
      name: "parametrizacion.usuario",
      component: () =>
        import("@/views/Parametrizacion/Usuario/UsuarioMainView.vue"),
      meta: {
        permission: "parametrizacion.usuario",
        menuName: "Parametrización",
        showSidebar: false,
        title: "Usuarios",
        layout: "MainLayout",
        mainView: "parametrizacion",
      },
      children: [
        {
          path: "/parametrizacion/usuario/nuevo",
          name: "parametrizacion.usuario.create",
          component: () =>
            import("@/views/Parametrizacion/Usuario/pages/FormUsuario.vue"),

          meta: {
            permission: "parametrizacion.usuario.create",
            showSidebar: false,
            title: "Crear usuario",
            mainView: "parametrizacion.usuario",
          },
        },
        {
          path: "/parametrizacion/usuario/update/id/:id",
          name: "parametrizacion.usuario.update",
          component: () =>
            import("@/views/Parametrizacion/Usuario/pages/FormUsuario.vue"),
          props: true,
          meta: {
            permission: "parametrizacion.usuario.update",
            showSidebar: false,
            title: "Editar usuario",
            mainView: "parametrizacion.usuario",
            reload: false,
          },
        },
      ],
    },
    {
      path: "/parametrizacion/hojagasto/insumo",
      name: "parametrizacion.hojagasto.insumo",
      component: () =>
        import("@/views/Parametrizacion/HojaGasto/Insumo/IndexInsumo.vue"),
      meta: {
        menuName: "Parametrización",
        showSidebar: false,
        title: "Insumos hoja de gastos",
        layout: "MainLayout",
        permission: "parametrizacion.hojagasto.insumo",
        mainView: "parametrizacion",
      },
      children: [
        {
          path: "add",
          name: "parametrizacion.hojagasto.insumo.create",
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/Insumo/pages/FormInsumo.vue"
            ),
          meta: {
            permission: "parametrizacion.hojagasto.insumo.create",
            iconClass: "fa-solid fa-gear",
            menuName: "Parametrización",
            title: "Crear insumo hoja de gastos",
            showSidebar: false,
            mainView: "parametrizacion.hojagasto.insumo",
            reload: true,
          },
        },
        {
          path: "edit/id/:id",
          name: "parametrizacion.hojagasto.insumo.update",
          props: true,
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/Insumo/pages/FormInsumo.vue"
            ),
          meta: {
            permission: "parametrizacion.hojagasto.insumo.update",
            iconClass: "fa-solid fa-gear",
            menuName: "Parametrización",
            title: "Editar insumo hoja de gastos",
            showSidebar: false,
            mainView: "parametrizacion.hojagasto.insumo",
            reload: false,
          },
        },
      ],
    },
    {
      path: "/parametrizacion/hojagasto/precargainsumo",
      name: "parametrizacion.hojagasto.precargainsumo",
      component: () =>
        import(
          "@/views/Parametrizacion/HojaGasto/Precarga/IndexPrecargaInsumo.vue"
        ),
      meta: {
        permisssion: "parametrizacion.hojagasto.insumo",
        menuName: "Parametrización",
        showSidebar: false,
        permission: "parametrizacion.hojagasto.precargainsumo",
        mainView: "parametrizacion",
        layout: "MainLayout",
        title: "Precarga insumos hoja de gastos",
      },
      children: [
        {
          path: "/add",
          name: "parametrizacion.hojagasto.precargainsumo.create",
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/Precarga/pages/FormInsumoPrecarga.vue"
            ),
          meta: {
            iconClass: "fa-solid fa-gear",
            showSidebar: false,
            reload: true,
            mainView: "parametrizacion.hojagasto.precargainsumo",
            permission: "parametrizacion.hojagasto.precargainsumo.create",
            title: "Nuevo ",
          },
        },
        {
          path: "edit/id/:id",
          name: "parametrizacion.hojagasto.precargainsumo.update",
          props: true,
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/Precarga/pages/FormInsumoPrecarga.vue"
            ),
          meta: {
            iconClass: "fa-solid fa-gear",
            showSidebar: false,
            reload: false,
            mainView: "parametrizacion.hojagasto.precargainsumo",
            permission: "parametrizacion.hojagasto.precargainsumo.update",
          },
        },
        {
          path: "edit/id/:id",
          name: "parametrizacion.hojagasto.precargainsumo.delete",
          props: true,
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/Precarga/pages/FormInsumoPrecarga.vue"
            ),
          meta: {
            iconClass: "fa-solid fa-gear",
            showSidebar: false,
            reload: false,
            mainView: "parametrizacion.hojagasto.precargainsumo",
            permission: "parametrizacion.hojagasto.precargainsumo.delete",
          },
        },
      ],
    },
    {
      path: "/parametrizacion/hojagasto/canastainsumo",
      name: "parametrizacion.hojagasto.canastainsumo",
      component: () =>
        import(
          "@/views/Parametrizacion/HojaGasto/CanastaInsumos/CanastaInsumosMainView.vue"
        ),
      meta: {
        permisssion: "parametrizacion.hojagasto.canasta",
        menuName: "Parametrización",
        showSidebar: false,
        mainView: "parametrizacion",
        layout: "MainLayout",
        title: "Canasta insumos hoja de gastos",
      },
      children: [
        {
          path: "add",
          name: "parametrizacion.hojagasto.canastainsumo.create",
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/CanastaInsumos/pages/FormInsumoCanasta.vue"
            ),
          meta: {
            permission: "parametrizacion.hojagasto.canasta.create",
            iconClass: "fa-solid fa-gear",
            menuName: "Parametrización",
            title: "Agregar insumo canasta",
            showSidebar: false,
            mainView: "parametrizacion.hojagasto.canastainsumo",
            reload: true,
          },
        },
        {
          path: "edit/id/:id",
          name: "parametrizacion.hojagasto.canastainsumo.update",
          props: true,
          component: () =>
            import(
              "@/views/Parametrizacion/HojaGasto/CanastaInsumos/pages/FormInsumoCanasta.vue"
            ),
          meta: {
            permission: "parametrizacion.hojagasto.canasta.update",
            iconClass: "fa-solid fa-gear",
            menuName: "Parametrización",
            title: "Editar insumo hoja de gastos",
            showSidebar: false,
            mainView: "parametrizacion.hojagasto.canastainsumo",
            reload: false,
          },
        },
      ],
    },
    // revisar el socket funcionamiento
    {
      path: "/apptest",
      name: "apptest",
      component: () => import("@/views/Test/pages/SocketTest.vue"),
      meta: {
        iconClass: "fa-solid fa-code",
        menuName: "Aplication tests",
        showSidebar: true,
        permission: "parametrizacion",
        layout: "MainLayout",
        title: "Socket Test",
      },
    },
    //historia clinica
    {
      path: "/historiaclinica/:id",
      name: "historiaclinica",
      props: true,
      component: () =>
        import("../views/HistoriaClinica/IndexHistoriaClinica.vue"),
      meta: {
        showSidebar: false,
        title: "Historia clínica",
        layout: "MainLayout",
        permission: "hc",
      },
      children: [
        {
          path: "controlsignos",
          name: "historiaclinica.controlsignos",
          layout: "HojaGastoLayout",
          component: () =>
            import(
              "../views/HistoriaClinica/ControlSignos/IndexControlSignos.vue"
            ),
          meta: {
            showSidebar: false,
            title: "Control de signos",
            permission: "hc.controlsignosvitales",
            layout: "MainLayout",
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.controlsignos.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/ControlSignos/components/NuevoControlSignos.vue"
                ),
              meta: {
                title: "Nuevo registro signos",
                permission: "hc.controlsignosvitales.create",
                layout: "MainLayout",
              },
            },
            {
              path: "edit/:registroid",
              name: "historiaclinica.controlsignos.update",
              props: true,
              component: () =>
                import(
                  "../views/HistoriaClinica/ControlSignos/components/NuevoControlSignos.vue"
                ),
              meta: {
                title: "Editar signos",
                permission: "hc.controlsignosvitales",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "alergias",
          name: "historiaclinica.alergias",
          props: true,
          component: () =>
            import("../views/HistoriaClinica/Alergias/IndexAlergiaHc.vue"),
          meta: {
            title: "Notas de enfermería",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            /*CHECHEAR SI EXISTE EL ID*/
            return true;
          },
        },
        {
          path: "valoracionanestesica",
          name: "historiaclinica.valoracionanestesicaquirurgica",
          component: () =>
            import(
              "@/views/HistoriaClinica/ValoracionAnestesicaQuirurgica/IndexValoracionAnestesica.vue"
            ),
          meta: {
            layout: "MainLayout",
            title: "Valoración anestésica quirúrgica",
            permission: "hc.valoracionanestesicaquirurgica",

          },
          props: true,
        },
        {
          path: "notasenfermeria",
          name: "historiaclinica.notasenfermeria",
          component: () =>
            import(
              "../views/HistoriaClinica/NotasEnfermeria/IndexNotaEnfermeria.vue"
            ),
          meta: {
            title: "Notas de enfermería",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            /*CHECHEAR SI EXISTE EL ID*/
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.notasenfermeria.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/NotasEnfermeria/components/NuevaNota.vue"
                ),
              meta: {
                title: "Nueva nota de enfermería",
                permission: "hc.notasenfermeria.create",
                layout: "MainLayout",
              },
            },
            {
              path: "edit/:registroid",
              name: "historiaclinica.notasenfermeria.editar",
              component: () =>
                import(
                  "../views/HistoriaClinica/NotasEnfermeria/components/NuevaNota.vue"
                ),
              meta: {
                title: "Editar nota enfermería",
                permission: "hc.notasenfermeria.update",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "controlliquidos",
          name: "historiaclinica.controlliquidos",
          component: () =>
            import(
              "../views/HistoriaClinica/ControlLiquidos/IndexControlLiquidos.vue"
            ),
          meta: {
            title: "Control de líquidos",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.controlliquidos.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/ControlLiquidos/components/NuevoControlLiquidos.vue"
                ),
              meta: {
                title: "Nueva líquido",
                permission: "hc.controlliquido.create",
                layout: "MainLayout",
              },
            },
            {
              path: "edit/:registroid",
              name: "historiaclinica.controlliquidos.editar",
              component: () =>
                import(
                  "../views/HistoriaClinica/ControlLiquidos/components/NuevoControlLiquidos.vue"
                ),
              meta: {
                title: "Editar líquido",
                permission: "hc.controlliquido.update",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "ordenmedicamentos",
          name: "historiaclinica.ordenmedicamentos",
          component: () =>
            import(
              "../views/HistoriaClinica/OrdenMedicamentos/IndexOrdenMedicamentos.vue"
            ),
          meta: {
            title: "Orden de medicamentos",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.ordenmedicamentos.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/OrdenMedicamentos/pages/FormOrdenMedicamento.vue"
                ),
              meta: {
                title: "Nueva orden de medicamento",
                permission: "hc.ordenmedicamentos.create",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "ordenmedica",
          name: "historiaclinica.ordenmedica",
          component: () =>
            import(
              "../views/HistoriaClinica/EvolucionOrdenesMedicas/OrdenMedicaMainView.vue"
            ),
          meta: {
            title: "Ordenes médicas",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.ordenmedica.nuevo1",
              component: () =>
                import(
                  "../views/HistoriaClinica/EvolucionOrdenesMedicas/pages/FormOrdenInicial.vue"
                ),
              meta: {
                title: "Nueva orden de medicamento",
                permission: "hc.ordenmedicamentos.create",
                layout: "MainLayout",
              },
            },
            {
              path: "nuevo",
              name: "historiaclinica.ordenmedica.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/EvolucionOrdenesMedicas/pages/FormOrdenMedica.vue"
                ),
              meta: {
                title: "Nueva orden de medicamento",
                permission: "hc.ordenmedicamentos.create",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "colgajo",
          name: "historiaclinica.colgajo",
          component: () =>
            import("../views/HistoriaClinica/Colgajo/IndexColgajo.vue"),
          meta: {
            title: "Colgajo",
            permission: "hc.colgajo",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            /*CHECHEAR SI EXISTE EL ID*/
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.colgajo.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/Colgajo/pages/FormularioColgajo.vue"
                ),
              meta: {
                title: "Nuevo colgajo",
                permission: "hc.colgajo.create",
                layout: "MainLayout",
              },
            },
            {
              path: "edit/:registroid",
              name: "hc.colgajo.update",
              component: () =>
                import(
                  "../views/HistoriaClinica/Colgajo/pages/FormularioColgajo.vue"
                ),
              meta: {
                title: "Editar colgajo",
                permission: "hc.colgajo.update",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "lipoinyeccion",
          name: "historiaclinica.lipoinyeccion",
          component: () =>
            import(
              "../views/HistoriaClinica/Lipoinyeccion/IndexLipoinyeccion.vue"
            ),
          meta: {
            title: "Lipoinyeccion",
            permission: "hc.lipoinyeccion",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            /*CHECHEAR SI EXISTE EL ID*/
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.lipoinyeccion.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/Lipoinyeccion/pages/FormularioLipoinyeccion.vue"
                ),
              meta: {
                title: "Nueva lipoinyección",
                permission: "hc.lipoinyeccion.create",
                layout: "MainLayout",
              },
            },
            {
              path: "edit/:registroid",
              name: "historiaclinica.lipoinyeccion.edit",
              component: () =>
                import(
                  "../views/HistoriaClinica/ControlLiquidos/components/NuevoControlLiquidos.vue"
                ),
              meta: {
                title: "Editar lipoinyección",
                permission: "hc.lipoinyeccion.update",
                layout: "MainLayout",
              },
            },
          ],
        },
        {
          path: "implante",
          name: "historiaclinica.implante",
          component: () =>
            import("../views/HistoriaClinica/Implantes/IndexImplantes.vue"),
          meta: {
            title: "Implantes",
            permission: "hc.implante",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            /*CHECHEAR SI EXISTE EL ID*/
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.implante.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/Implantes/components/NuevoImplante.vue"
                ),
              meta: {
                title: "Nuevo registro",
                permission: "hc.implante.create",
                layout: "MainLayout",
              },
            },
            {
              path: "edit/:registroid",
              name: "historiaclinica.implante.update",
              component: () =>
                import(
                  "../views/HistoriaClinica/Implantes/components/NuevoImplante.vue"
                ),
              meta: {
                title: "Editar implante",
                permission: "hc.implante.update",
                layout: "HojaGastoLayout",
              },
            },
          ],
        },
        {
          path: "canalizacion",
          name: "historiaclinica.canalizacion",
          component: () =>
            import(
              "../views/HistoriaClinica/Canalizacion/IndexCanalizacion.vue"
            ),
          meta: {
            title: "Canalización",
            permission: "hc.canalizacion",
            layout: "MainLayout",
          },
          beforeEnter: (to, from) => {
            /*CHECHEAR SI EXISTE EL ID*/
            return true;
          },
          children: [
            {
              path: "nuevo",
              name: "historiaclinica.canalizacion.nuevo",
              component: () =>
                import(
                  "../views/HistoriaClinica/Canalizacion/Pages/NuevaCanalizacion.vue"
                ),
              meta: {
                title: "Nueva canalización",
                permission: "hc.canalizacion.create",
                layout: "MainLayout",
              },
            },
            {
              path: "retiro/:registroid",
              name: "historiaclinica.canalizacion.retiro",
              component: () =>
                import(
                  "../views/HistoriaClinica/Canalizacion/Retiro/IndexRetiro.vue"
                ),
              meta: {
                title: "Retiro de canalización",
                permission: "hc.canalizacion.retiro",
                layout: "MainLayout",
              },
            },
            {
              path: "segcanalizacion",
              name: "historiaclinica.canalizacion.segcanalizacion",
              component: () =>
                import(
                  "../views/HistoriaClinica/Canalizacion/Seguimiento/Pages/NuevoSeguimiento.vue"
                ),
              meta: {
                title: "Seguimiento canalización",
                permission: "hc.canalizacion",
                layout: "MainLayout",
              },
              beforeEnter: (to, from) => {
                /*CHECHEAR SI EXISTE EL ID*/
                return true;
              },
              children: [
                {
                  path: "nuevo",
                  name: "historiaclinica.canalizacion.segcanalizacion.nuevo",
                  props: true,
                  component: () =>
                    import(
                      "../views/HistoriaClinica/Canalizacion/Pages/NuevaCanalizacion.vue"
                    ),
                  meta: {
                    title: "Nuevo seguimiento",
                    permission: "hc.canalizacion.create",
                    layout: "MainLayout",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "recuperacionpostanestesica",
          name: "historiaclinica.recuperacionpostanestesica",
          component: () =>
            import(
              "../views/HistoriaClinica/RecuperacionPostAnestesica/IndexRecPostAnestesica.vue"
            ),
          meta: {
            title: "Recuperación post anestésica",
            permission: "hc.recuperacionpostanestesica",
            layout: "HojaGastoLayout",
          },
          beforeEnter: (to, from) => {
            return true;
          },
          children: [
            {
              path: "testaldrete/nuevo",
              name: "hc.recuperacionpostanestesica.testaldrete.create",
              component: () =>
                import(
                  "../views/HistoriaClinica/RecuperacionPostAnestesica/pages/FormRecpPostAnetesica.vue"
                ),
              meta: {
                title: "Nuevo registro",
                permission: "hc.recuperacionpostanestesica.create",
                layout: "HojaGastoLayout",
              },
            },
            {
              path: "observacion/nuevo",
              name: "hc.recuperacionpostanestesica.observacion.create",
              component: () =>
                import(
                  "../views/HistoriaClinica/RecuperacionPostAnestesica/pages/FormObservacion.vue"
                ),
              meta: {
                title: "Nuevo registro",
                permission: "hc.recuperacionpostanestesica.observacion.create",
                layout: "HojaGastoLayout",
              },
            },
            {
              path: "hemorragia/nuevo",
              name: "hc.recuperacionpostanestesica.hemorragia.create",
              component: () =>
                import(
                  "../views/HistoriaClinica/RecuperacionPostAnestesica/pages/FormHemorragia.vue"
                ),
              meta: {
                title: "Nuevo registro",
                permission: "hc.recuperacionpostanestesica.hemorragia.create",
                layout: "HojaGastoLayout",
              },
            },
          ],
        },
        // {
        //   path: "recuperacionpostanestesica/nuevo",
        //   name: "hc.recuperacionpostanestesica.create",
        //   component: () =>
        //     import(
        //       "../views/HistoriaClinica/RecuperacionPostAnestesica/pages/FormRecpPostAnetesica.vue"
        //     ),
        //   meta: {
        //     title: "Recuperación post anestésica",
        //     permission: "hc.recuperacionpostanestesica.create",
        //     layout: "HojaGastoLayout",
        //   },
        //   beforeEnter: (to, from) => {
        //     return true;
        //   },
        // },
      ],
    },
    //control de visitantes
    {
      path: "/controlvisitante",
      name: "controlvisitante",
      component: () =>
        import("@/views/ControlVisitante/IndexControlVisitante.vue"),
      meta: {
        iconClass: "fa-solid fa-person-circle-check",
        menuName: "Control visitante",
        showSidebar: true,
        title: "Control de visitantes",
        permission: "controlvisitante",
        layout: "MainLayout",
      },
    },
    // encuesta de satisfaccion
    {
      path: "/encuestasatisfaccion",
      name: "encuestasatisfaccion",
      component: () => import("@/views/EncuestaSatisfaccion/Index.vue"),
      meta: {
        iconClass: "fa-solid fa-clipboard-list",
        menuName: "Encuesta satisfacción",
        showSidebar: true,
        title: "Encuesta de satisfacción",
        permission: "encuestasatisfaccion",
        layout: "MainLayout",
      },
      children: [
        {
          path: "edit/id/:id",
          name: "encuestasatisfaccion.update",
          component: () =>
            import("@/views/EncuestaSatisfaccion/pages/FormEncuesta.vue"),
          meta: {
            title: "Encuesta satisfacción",
            permission: "encuestasatisfaccion",
            layout: "MainLayout",
            mainView: "encuestasatisfaccion",
          },
        },
        {
          path: "/view/id/:id",
          name: "encuestasatisfaccion.view",
          component: () =>
            import("@/views/EncuestaSatisfaccion/pages/FormEncuesta.vue"),
          meta: {
            title: "Encuesta satisfacción",
            permission: "encuestasatisfaccion",
            layout: "MainLayout",
            mainView: "encuestasatisfaccion",
          },
        },
      ],
    },

    {
      path: "/farmacia",
      name: "farmacia",
      component: () => import("@/views/Farmacia/FarmaciaMainView.vue"),
      meta: {
        iconClass: "fa-solid fa-capsules",
        menuName: "Almacén",
        showSidebar: true,
        title: "Farmacia",
        permission: "encuestasatisfaccion",
        layout: "MainLayout",
      },
    },
    {
      path: "/asistencia",
      name: "controlasistencia",
      component: () => import("@/views/ControlAsistencia/MainViewControlAsistencia.vue"),
      meta: {
        iconClass: "fa-solid fa-user-clock",
        menuName: "Control asistencia",
        showSidebar: true,
        title: "Control asistencia",
        permission: "controlasistencia",
        layout: "MainLayout",
      },
    },
    {
      path: "/asistencia/registros",
      name: "controlasistencia.registrosasistencia",
      component: () => import("@/views/ControlAsistencia/Registros/MainViewRegistrosAsistencia.vue"),
      meta: {
        iconClass: "fa-solid fa-user-clock",
        menuName: "Control asistencia",
        showSidebar: false,
        title: "Registros asistencia",
        permission: "controlasistencia.registrosasistencia",
        layout: "MainLayout",
        mainView: "controlasistencia",
      },
    },
    {
      path: "/asistencia/reportegeneral",
      name: "controlasistencia.reportegeneral",
      component: () => import("@/views/ControlAsistencia/ReporteGeneral/MainViewLiquidaciones.vue"),
      meta: {
        iconClass: "fa-solid fa-user-clock",
        menuName: "Control asistencia",
        showSidebar: false,
        title: "Registros asistencia",
        permission: "controlasistencia.registrosasistencia",
        layout: "MainLayout",
        mainView: "controlasistencia",
      },
    },
    {
      path: "/asistencia/registros/importar",
      name: "controlasistencia.registrosasistencia.importar",
      component: () => import("@/views/ControlAsistencia/Registros/pages/ImportRegistros.vue"),
      meta: {
        iconClass: "fa-solid fa-user-clock",
        showSidebar: false,
        title: "Importar registros de asistencia",
        permission: "controlasistencia.registrosasistencia",
        layout: "MainLayout",
        mainView: "controlasistencia.registrosasistencia",
      },
    },
    {
      path: "/asistencia/parametrizacionturno",
      name: "controlasistencia.parametrizacionturno",
      component: () => import("@/views/ControlAsistencia/ParametrizacionTurno/MainViewParametrizacionTurno.vue"),
      meta: {
        iconClass: "fa-solid fa-user-clock",
        menuName: "Control asistencia",
        showSidebar: false,
        title: "Parametrización de turnos",
        permission: "controlasistencia.registrosasistencia",
        layout: "MainLayout",
        mainView: "controlasistencia",
      },
    },
    {
      path: "/asistencia/asignacionturno",
      name: "controlasistencia.asignacionturno",
      component: () => import("@/views/ControlAsistencia/AsignacionTurno/MainViewAsignacionTurno.vue"),
      meta: {
        iconClass: "fa-solid fa-user-clock",
        menuName: "Control asistencia",
        showSidebar: false,
        title: "Asignación de turnos",
        permission: "controlasistencia.registrosasistencia",
        layout: "MainLayout",
        mainView: "controlasistencia",
      },
    },
    {
      path: "/reporte",
      name: "reporte",
      component: () => import("@/views/Reporte/IndexReporte.vue"),
      meta: {
        iconClass: "fa-solid fa-chart-line",
        menuName: "Reportes",
        showSidebar: true,
        title: "Reportes",
        permission: "reporte",
        layout: "MainLayout",
      },
    },
    {
      path: "/reporte/copanem",
      name: "reporte.copanem",
      component: () =>
        import(
          "@/views/Reporte/Copanem/ReporteCopanemMainView.vue"
        ),
      meta: {
        title: "Reporte COPANEM",
        permission: "reporte.copanem",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/encuestasatisfaccion",
      name: "reporte.encuestasatisfaccion",
      component: () =>
        import(
          "@/views/Reporte/encuestasatisfaccion/ReporteEncSatisfaccionMainView.vue"
        ),
      meta: {
        title: "Reporte Encuesta satisfacción",
        permission: "reporte.encuestasatisfaccion",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/resolucion256",
      name: "reporte.resolucion256",
      component: () =>
        import(
          "@/views/Reporte/Resolucion256/ReporteRel256MainView.vue"
        ),
      meta: {
        title: "Reporte resolución 256",
        permission: "reporte.resolucion256",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },




    {
      path: "/reporte/libro/consulta",
      name: "reporte.libro.consulta",
      component: () =>
        import("@/views/Reporte/Libro/Consulta/LibroConsulta.vue"),
      meta: {
        title: "Libro consulta",
        permission: "reporte.libro.consulta",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/libro/cirugia",
      name: "reporte.libro.cirugia",
      component: () => import("@/views/Reporte/Libro/Cirugia/LibroCirugia.vue"),
      meta: {
        title: "Libro cirugía",
        permission: "reporte.libro.cirugia",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/libro/recuperacion",
      name: "reporte.libro.recuperacion",
      component: () =>
        import("@/views/Reporte/Libro/Recuperacion/LibroRecuperacion.vue"),
      meta: {
        title: "Libro recuperación",
        permission: "reporte.libro.recuperacion",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/libro/hospitalizacion",
      name: "reporte.libro.hospitalizacion",
      component: () =>
        import(
          "@/views/Reporte/Libro/Hospitalizacion/LibroHospitalizacion.vue"
        ),
      meta: {
        title: "Libro hospitalización",
        permission: "reporte.libro.hospitalizacion",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/fevrips/consultaexterna",
      name: "reporte.fevrips.consultaexterna",
      component: () =>
        import(
          "@/views/Reporte/FevRips/ConsultaExterna/ReporteFevRipsConsExt.vue"
        ),
      meta: {
        title: "Reporte FEV RIPS consulta externa",
        permission: "reporte.fevrips.consultaexterna",

        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/fevrips/cirugia",
      name: "reporte.fevrips.cirugia",
      component: () =>
        import("@/views/Reporte/FevRips/Cirugia/ReporteFevRipsCirugia.vue"),
      meta: {
        title: "Reporte FEV RIPS cirugía",
        permission: "reporte.fevrips.cirugia",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },

    {
      path: "/reporte/fevrips/hospitalizacion",
      name: "reporte.fevrips.hospitalizacion",
      component: () =>
        import(
          "@/views/Reporte/FevRips/Hospitalizacion/ReporteFevRipsHospitalizacion.vue"
        ),
      meta: {
        title: "Reporte FEV RIPS hospitalización",
        permission: "reporte.fevrips.hospitalizacion",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },
    {
      path: "/device/enroll",
      name: "device.enroll",
      component: () =>
        import(
          "@/views/Device/Enroll/EnrollDeviceMainView.vue"
        ),
      meta: {
        title: "Asociar dispositivo",
        permission: "device.enroll",
        layout: "MainLayout",
        mainView: "reporte",
      },
    },
    //fin rutas
    {
      path: "/no-permiso",
      name: "NoPermiso",
      component: () => import("@/views/NoPermiso.vue"),
      meta: {
        public: true
      },
    },
    {
      path: "/no-autorizado",
      name: "NoAutorizado",
      component: () => import("@/views/Unauthorized.vue"),
      meta: { public: true },
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: () => import("@/views/NotFound.vue"),
    },
  ],
});

router.onError((error) => {
  console.error("Router error:", error);
});

// router.beforeEach(async (to) => {
//   const publicPages = ["/login", "/register"];
//   const authRequired = !publicPages.includes(to.path);
//   const auth = useAuthStore();

//   if (authRequired) {
//     if (auth.user) {
//       await auth.checkAuth();
//     }

//     if (!auth.user) {
//       auth.returnUrl = to.fullPath;
//       return "/login";
//     } else {
//       if (
//         !to.meta.permission ||
//         to.meta.permission === undefined ||
//         !auth.permisos.includes(to.meta.permission)
//       ) {
//         console.log(to);
//         auth.setFlash("No tienes permiso para acceder a esta sección.");
//         console.log(to.meta.permission);
//         //alert(to.meta.permission);
//         return "/";
//       }
//     }
//   }
// });

/*CHATGPT*/
// router.beforeEach(async (to) => {
//   const publicPages = [
//     "/login",
//     "/register",
//     "/no-permiso",
//     "/forgotpassword",
//     "/reset-password",
//   ];

//   const publicDynamicPages = [
//     "/historiaclinica/condsaludantecedentemedico/",
//   ];

//   const isPublicPage =
//     publicPages.includes(to.path) ||
//     publicDynamicPages.some(path => to.path.startsWith(path));

//   const authRequired = !isPublicPage;

//   const auth = useAuthStore();

//   if (authRequired) {

//     await auth.checkAuth();

//     if (!auth.authUser) {
//       auth.returnUrl = to.fullPath;
//       return "/login";
//     }

//     const permisoRequerido = to.meta.permission;

//     const tienePermiso =
//       !permisoRequerido ||
//       auth.permisos.includes(permisoRequerido);

//     if (!tienePermiso) {
//       return "/no-permiso";
//     }
//   }

//   return true;
// });

router.beforeEach(async (to) => {

  const auth = useAuthStore();

  // Ruta pública
  if (to.meta.public) {
    return true;
  }

  if (auth.isLoggingOut || !auth.authToken) {
    return "/login";
  }

  const validSession = await auth.checkAuth();

  if (!validSession || auth.isLoggingOut || !auth.authUser || !auth.authToken) {
    auth.returnUrl = to.fullPath;
    return "/login";
  }

  const permisoRequerido = to.meta.permission;

  const tienePermiso =
    !permisoRequerido ||
    auth.permisos.includes(permisoRequerido);

  if (!tienePermiso) {
    return "/no-permiso";
  }

  return true;
});

//global para actualizar el título
router.afterEach((to) => {
  const defaultTitle = "MedicalDhara";
  document.title = to.meta.menuName
    ? `${to.meta.menuName} - MedicalDhara`
    : defaultTitle;
});

export default router;
